
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <Button label="Skapa ny" @click="createDetails()" icon="pi pi-plus" ></Button>
        <Button :label="inActiveBtnText" @click="showInactive()" icon="pi pi-eye" ></Button><br/><br/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
         <table class="table-hover orderList" v-if="users">
            <thead>
              <tr>
                <th>Förnamn</th>
                <th>Efternamn</th>
                <th>E-post</th>
                <th>App-version</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in filteredUsers" :key="user.id" v-on:click="openUser(user.id)">
                <td>{{ user.firstName }}</td>
                <td>{{ user.lastName }}</td>
                <td>{{ user.email }}</td>
                <td><span v-if="user.data !== null && user.data.appVersion !== null">{{ user.data.appVersion }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <Button  label="Skapa ny" @click="createDetails()" icon="pi pi-plus" ></Button>
         <!--<router-link to="/usercreate">Skapa användare</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button'
export default {
  name: 'UserList',
  components: {
    Button
  },
  data () {
    return {
      msg: 'Användare',
      users: [],
      showFilteredUsers: false,
      inActiveBtnText: 'Visa inaktiva'
    }
  },
  computed: {
    filteredUsers () {
      if (this.showFilteredUsers) {
        return this.users.filter(function (user) {
          if (user.inActive === 'Ja') {
            return user
          }
        })
      } else {
        return this.users.filter(function (user) {
          if (user.inActive === null || user.inActive === 'Nej') {
            return user
          }
        })
      }
    }
  },
  mounted () {
    this.$http
      .get('/api/users')
      .then(response => { this.users = response.data })
      .catch(error => console.log(error))
  },
  methods: {
    createDetails () {
      this.$router.push({ name: 'UserCreate' })
    },
    showInactive () {
      if (this.showFilteredUsers) {
        this.showFilteredUsers = false
        this.inActiveBtnText = 'Visa inaktiva'
      } else {
        this.showFilteredUsers = true
        this.inActiveBtnText = 'Visa alla'
      }
    },
    openUser (id) {
      this.$router.push({ name: 'UserDetails', params: { id: id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/UserList.vue